import {AdminAgreementStatus} from './AdminAgreementDTO'

export type AdminAgreementDetailJSON = AdminAgreementDetailDTO

export interface AdminAgreementDetail {
  id: number
  content: string
  publishDateTime: string
  comment: string
  administratorName: string
  createdAt: string
  status: AdminAgreementStatus
  bucketKey: string | null
}

export class AdminAgreementDetailDTO implements AdminAgreementDetail {
  constructor(
    public id: number,
    public content: string,
    public publishDateTime: string,
    public comment: string,
    public administratorName: string,
    public createdAt: string,
    public status: AdminAgreementStatus,
    public bucketKey: string | null,
  ) {
  }

  static fromJSON(jsonObject: AdminAgreementDetailJSON): AdminAgreementDetail {
    return new AdminAgreementDetailDTO(
      jsonObject.id,
      jsonObject.content,
      jsonObject.publishDateTime,
      jsonObject.comment,
      jsonObject.administratorName,
      jsonObject.createdAt,
      ['active', 'inactive', 'expired'].includes(jsonObject.status) ? jsonObject.status : 'expired',
      jsonObject.bucketKey,
    )
  }
}
